__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "@shipbob/integrations_control_panel_ui";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@shipbob/auth", "1.2.0", () => (__webpack_require__.e(667).then(() => (() => (__webpack_require__(13667))))));
			register("@shipbob/rbac", "1.24.0", () => (Promise.all([__webpack_require__.e(421), __webpack_require__.e(533)]).then(() => (() => (__webpack_require__(83533))))));
			register("@shipbob/telemetry", "1.6.0", () => (__webpack_require__.e(36).then(() => (() => (__webpack_require__(21036))))));
			register("vue-router", "4.6.4", () => (Promise.all([__webpack_require__.e(965), __webpack_require__.e(352)]).then(() => (() => (__webpack_require__(74965))))));
			register("vue", "3.5.28", () => (__webpack_require__.e(31).then(() => (() => (__webpack_require__(45031))))));
			register("vuex", "4.0.2", () => (Promise.all([__webpack_require__.e(124), __webpack_require__.e(143)]).then(() => (() => (__webpack_require__(82124))))));
			initExternal(54137);
			initExternal(62445);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};